import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles, Grid } from '@material-ui/core'
import * as utils from '../utils'
import * as actions from '../actions'
import greyoff from '../images/svg/greyoff.svg'
import { CONTRACT, SOLD, ASSINGMENTS_LOCATION_LABEL } from '../constants'

const styles = theme => ({
  listRowData: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#333645',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  newBadge: {
    width: '41px',
    height: '18px',
    borderRadius: '10px',
    backgroundColor: 'rgba(255, 210, 0, 0.72)',
    border: 'solid 1px #ffd200',
    fontSize: '10px',
    fontWeight: '500',
    lineHeight: '1.6',
    letterSpacing: '0.8px',
    color: 'rgba(0, 0, 0, 0.8)',
    position: 'absolute',
    top: '-21px',
    right: '-21px',
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  propertyRowWrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '0 15px',
  },
  propertyRowContainer: {
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
  },
  listRowDataOne: {
    maxWidth: '50%',
    minWidth: '50%',
    display: 'flex',
    alignItems: 'center',
    color: '#838383',
    fontWeight: 'normal',
  },
  listRowDataTwo: {
    maxWidth: '12%',
    minWidth: '12%',
  },
  listRowDataThree: {
    maxWidth: '11%',
    minWidth: '11%',
  },
  listRowDataFour: {
    maxWidth: '15%',
    minWidth: '15%',
  },
  propertyRowVenue: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingRight: '10px',
    maxWidth: '500px',
  },
  propertyRowArea: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingRight: '10px',
    maxWidth: '350px',
  },
  propertyRowPrice: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingRight: '10px',
    maxWidth: '250px',
  },
  propertyRowEmptyGrid: {
    maxWidth: '5%',
    minWidth: '5%',
    textAlign: 'right',
  },
  propertyRowEmptyGridImage: {
    width: '28px',
    height: '28px',
    display: 'none',
  },
  propertyTag: {
    display: 'inline-block',
    margin: '0',
    padding: '3px 5px',
    fontSize: '11px',
    fontWeight: '500',
    color: '#fff',
    borderRadius: '0',
    position: 'absolute',
    top: '-21px',
    right: '-21px',
  },
  newTag: {
    backgroundColor: '#d24c4c',
  },
  soldTag: {
    backgroundColor: '#2fae54',
  },
  underTag: {
    backgroundColor: '#e4ad5e',
  },
})

function PropertyRow(props) {
  const { classes, property, actions, listOptions } = props
  const list = listOptions.map((key, index) => {
    // const classNames = index === 2 ? `${classes.listRowData} ${classes.listRowDataThree}` : index === 3 ? `${classes.listRowData} ${classes.listRowDataFour}` : `${classes.listRowData} ${classes.listRowDataTwo}`
    return (
      <Grid item className={`${classes.listRowData} ${classes.listRowDataTwo}`} key={`grid-item-${index}`}>
        <span
          className={
            key === 'price' && property.sellerLeadStage && property.sellerLeadStage.toLowerCase() === SOLD
              ? `strike-through ${classes.propertyRowPrice}`
              : classes.propertyRowPrice
          }>
          {property[key] !== null ? `${utils.withCommas(property[key] || 0)}` : ''}
        </span>
      </Grid>
    )
  })
  return (
    <div
      className={classes.propertyRowWrapper}
      onMouseEnter={() => actions.mapMarkerHover(parseInt(property.id, 10))}
      onMouseLeave={() => actions.mapMarkerHover(null)}>
      <Grid container className={classes.propertyRowContainer}>
        {/* {utils.isNewlyAddedProperty(property.createdAt) && <span className={classes.newBadge}>new</span>} */}
        {property.sellerLeadStage && property.sellerLeadStage.toLowerCase() === SOLD ? (
          <span className={`${classes.propertyTag} ${classes.soldTag}`}>Sold</span>
        ) : property.sellerLeadStage && property.sellerLeadStage.toLowerCase() === CONTRACT ? (
          <span className={`${classes.propertyTag} ${classes.underTag}`}>Under Contract</span>
        ) : property.startListingOn && utils.isNewlyListedProperty(property.startListingOn) ? (
          <span className={`${classes.propertyTag} ${classes.newTag}`}>New</span>
        ) : (
          ''
        )}
        <Grid item className={`${classes.listRowData} ${classes.listRowDataOne}`}>
          <span className={classes.propertyRowVenue}>
            {property.address && !(property.type && property.type.toLowerCase() === process.env.REACT_APP_ASSINGMENTS_PROPERTY_TYPE)
              ? `${property.address}, ${property.city}, ${property.state}`
              : `${ASSINGMENTS_LOCATION_LABEL}`}
          </span>
        </Grid>
        {list}
        {/* <Grid item className={`${classes.listRowData} ${classes.listRowDataTwo}`}>
          <span className={classes.propertyRowArea}>{`${utils.withCommas(property.sqft || 0)}`}</span>
        </Grid>
        <Grid item className={`${classes.listRowData} ${classes.listRowDataTwo}`}>
          <span className={classes.propertyRowArea}>{property.beds || 0}</span>
        </Grid>
        <Grid item className={`${classes.listRowData} ${classes.listRowDataThree}`}>
          <span className={classes.propertyRowArea}>{property.baths || 0}</span>
        </Grid>
        <Grid item className={`${classes.listRowData} ${classes.listRowDataFour}`}>
          <span
            className={
              property.sellerLeadStage && property.sellerLeadStage.toLowerCase() === SOLD
                ? `strike-through ${classes.propertyRowPrice}`
                : classes.propertyRowPrice
            }>{`$${utils.withCommas(property.price || 0)}`}</span>
        </Grid> */}
        <Grid item className={classes.propertyRowEmptyGrid}>
          <span
            onClick={evt => {
              evt.preventDefault()
            }}>
            <img className={classes.propertyRowEmptyGridImage} src={greyoff} alt={'greyoff'} />
          </span>
        </Grid>
      </Grid>
    </div>
  )
}

PropertyRow.propTypes = {
  classes: PropTypes.object.isRequired,
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

const proprow = connect(
  null,
  mapDispatchToProps
)(PropertyRow)

export default withStyles(styles)(proprow)



// WEBPACK FOOTER //
// ./src/components/PropertyRow.js